import { decl } from '@yandex-lego/i-bem-react';
export default decl({
  block: 'progress',
  attrs: function attrs() {
    var width = this.props.value <= 0 ? '0' : this.props.value >= 1 ? '100%' : (this.props.value * 100).toPrecision(2) + '%';
    return {
      style: {
        width: width
      }
    };
  },
  mods: function mods(_ref) {
    var timing = _ref.timing;
    return {
      timing: timing
    };
  }
});